
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.005 10.028a3.992 3.992 0 003.803-4.138 3.897 3.897 0 00-3.803-4.026 3.933 3.933 0 00-3.813 4.045 3.994 3.994 0 003.813 4.119zm0-1.392A2.559 2.559 0 017.676 5.91a2.481 2.481 0 012.329-2.654 2.47 2.47 0 012.328 2.635 2.57 2.57 0 01-2.328 2.746zm-5.502 9.528h10.994c1.484 0 2.19-.455 2.19-1.438 0-2.338-2.942-5.631-7.692-5.631-4.74 0-7.681 3.293-7.681 5.631 0 .983.705 1.438 2.19 1.438zm-.37-1.392c-.224 0-.316-.064-.316-.24 0-1.41 2.208-4.046 6.178-4.046s6.188 2.635 6.188 4.045c0 .177-.092.241-.315.241z"}})])
          )
        }
      }
    